var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 63.02 58.26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "star_svg__cls-1",
  d: "m7.8 52.93 16.18-22.28-24-8.57 3.62-8.76 22.46 8.38V0h10.92v21.7l22.47-8.38 3.62 8.76-24 8.38 16.18 22.27-8.57 5.34-15-21.14-15.23 21.33Z"
})));

export default SvgStar;